// extracted by mini-css-extract-plugin
export var circle = "_es-1";
export var exitConfirmationModal = "_es-5";
export var iframe = "_es-0";
export var offline = "_es-3";
export var online = "_es-2";
export var workstationSelectError = "_es-4";